import { Component, OnInit } from '@angular/core';
import { TransportistaService } from 'src/app/services/convenio/transportista.service';

@Component({
  selector: 'app-dahsboard-cobro',
  templateUrl: './dahsboard-cobro.component.html',
  styleUrls: ['./dahsboard-cobro.component.scss']
})
export class DahsboardCobroComponent implements OnInit {
  openTab = 1;
  dataTransportistas:any
  constructor(
    private transportistaService: TransportistaService) { }

  ngOnInit(): void {

  }

  toggleTabs($tabNumber: number){
    this.openTab = $tabNumber;
    if ($tabNumber==2) {
      this.consultarTransportistas()
    }
  }
  consultarTransportistas() {
    this.transportistaService.getTransportistas().
      subscribe(data => {
        this.dataTransportistas = data;
    })

  }

}

